export default __webpack_public_path__ + "static/media/school.76ec8727.svg";